import { BONDS_STORE_NAME } from '@/creditflowresearch/application/Bonds/constants';
import CurrentFaceRangeWithList from '@/creditflowresearch/ui/components/bonds/common/BondsSidebar/Sections/CurrentFaceRangeWithList';
import { CURRENT_FACE_RANGE_PRESET_FILTER_NAME } from '@/creditflowresearch/ui/components/bonds/common/BondsSidebar/constants';
import formatNumber from '@framework/data-helpers/formatters/formatNumber';
import { useFiltersContext } from '@framework/ui/Organisms/Filters/FiltersContext';
import { useBondsFiltersContext } from '@/creditflowresearch/application/Bonds/BondsFiltersContext';

const CurrentFaceRangeWithListContainer = (props) => {
  const { filterName } = props;
  const { items: { filter } } = useBondsFiltersContext();
  const { getFiltersByFilterName } = useFiltersContext();
  const defaultRangeValue = filter[filterName];
  const filters = getFiltersByFilterName(BONDS_STORE_NAME, filterName);
  const isFilterExists = !!filters;

  return (
    <CurrentFaceRangeWithList
      { ...props }
      selectedRangeValue={ isFilterExists ? filters.range : defaultRangeValue }
      minValue={ isFilterExists ? filters.minValue : defaultRangeValue.min }
      maxValue={ isFilterExists ? filters.maxValue : defaultRangeValue.max }
      isRangeDisabled={
        isFilterExists
          ? !!getFiltersByFilterName(BONDS_STORE_NAME, CURRENT_FACE_RANGE_PRESET_FILTER_NAME).length
          : false
      }
      filters={
        isFilterExists ?
          getFiltersByFilterName(BONDS_STORE_NAME, CURRENT_FACE_RANGE_PRESET_FILTER_NAME) : []
      }
      inputValueFormatter={ formatNumber }
    />
  );
};

export default CurrentFaceRangeWithListContainer;
